var _style, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 569 569",
    style: {
      enableBackground: "new 0 0 569 569"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M483.3,427.2c31.3-42.3,48.1-93.6,48-146.2c0-136.1-110.3-246.5-246.4-246.5S38.4,144.9,38.4,281 s110.3,246.4,246.5,246.4c32.2,0.1,64-6.2,93.8-18.4c21.3-8.8,106.1,39.2,123.9,25.1C519.8,520.4,470.2,444.9,483.3,427.2z  M180.2,324.7c-22,0-39.9-17.9-39.9-39.9s17.9-39.9,39.9-39.9s39.9,17.9,39.9,39.9l0,0C220.1,306.9,202.2,324.7,180.2,324.7 L180.2,324.7z M286,324.7c-21.7,0-39.3-17.6-39.3-39.3s17.6-39.3,39.3-39.3s39.3,17.6,39.3,39.3C325.3,307.1,307.7,324.7,286,324.7 L286,324.7z M391.7,324.7c-22,0-39.9-17.9-39.9-39.9s17.9-39.9,39.9-39.9s39.9,17.9,39.9,39.9l0,0 C431.6,306.9,413.8,324.7,391.7,324.7L391.7,324.7z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.9,18C139.5,18,22,135.4,22,279.8s117.5,261.9,261.9,261.9c29.9,0,59.5-5.1,87.7-15.2L513,551.3 c0.7,0.1,1.4,0.1,2.1,0.1c4.2,0,8.1-2.1,10.4-5.6c2.3-3.5,2.7-7.9,1.1-11.7l-38.5-90.6c37.4-46.3,57.7-104.1,57.6-163.6 C545.7,135.4,428.3,18,283.9,18z M504.6,366.1c-9.6,24.5-23.3,47.1-40.4,67.1c-3.1,3.6-3.9,8.6-2,13l32.5,76.6l-122.2-21.3 c-0.7-0.1-1.4-0.1-2.1-0.1c-1.5,0-3,0.2-4.4,0.7c-26.3,9.8-54.1,14.8-82.2,14.8C153.2,516.9,46.9,410.6,46.9,280 c0-130.7,106.2-236.9,236.9-236.9S520.7,149.3,520.7,280C520.8,309.4,515.3,338.7,504.6,366.1z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M283.9,18C139.5,18,22,135.4,22,279.8s117.5,261.9,261.9,261.9c29.9,0,59.5-5.1,87.7-15.2L513,551.3 c0.7,0.1,1.4,0.1,2.1,0.1c4.2,0,8.1-2.1,10.4-5.6c2.3-3.5,2.7-7.9,1.1-11.7l-38.5-90.6c37.4-46.3,57.7-104.1,57.6-163.6 C545.7,135.4,428.3,18,283.9,18z M504.6,366.1c-9.6,24.5-23.3,47.1-40.4,67.1c-3.1,3.6-3.9,8.6-2,13l32.5,76.6l-122.2-21.3 c-0.7-0.1-1.4-0.1-2.1-0.1c-1.5,0-3,0.2-4.4,0.7c-26.3,9.8-54.1,14.8-82.2,14.8C153.2,516.9,46.9,410.6,46.9,280 c0-130.7,106.2-236.9,236.9-236.9S520.7,149.3,520.7,280C520.8,309.4,515.3,338.7,504.6,366.1z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M391.2,244.1c-22.5,0-40.7,18.2-40.7,40.6c0,22.5,18.2,40.7,40.7,40.7c22.4,0,40.6-18.2,40.6-40.7 C431.9,262.3,413.7,244.1,391.2,244.1z M391.2,300.4c-8.7,0-15.7-7-15.7-15.7s7-15.7,15.7-15.7s15.7,7,15.7,15.7 C406.9,293.4,399.9,300.4,391.2,300.4z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M284.9,244.1c-22.5,0-40.7,18.2-40.7,40.6c0,22.5,18.2,40.7,40.7,40.7c22.4,0,40.6-18.2,40.6-40.7 C325.5,262.3,307.3,244.1,284.9,244.1z M284.9,300.4c-8.7,0-15.7-7-15.7-15.7s7-15.7,15.7-15.7s15.7,7,15.7,15.7 S293.5,300.4,284.9,300.4z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M179.5,244.1c-22.5,0-40.7,18.2-40.7,40.6c0,22.5,18.2,40.7,40.7,40.7c22.4,0,40.6-18.2,40.6-40.7 C220.1,262.3,201.9,244.1,179.5,244.1z M179.5,300.4c-8.7,0-15.7-7-15.7-15.7s7-15.7,15.7-15.7s15.7,7,15.7,15.7 S188.2,300.4,179.5,300.4z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.841659982d906ae302a4780ea74c8315.svg";
export { ForwardRef as ReactComponent };